module.exports = __webpack_public_path__ + "static/img/07.d4d7507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/07.jpg
// module id = zzHU
// module chunks = 0